import { FC } from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import CompanySetup from './Setup';
import CompanySettings from './Settings';
import { useAuth } from '@hooks/Auth';
import { Tier } from '@sdk/API';

const CompanyRouter: FC = () => {
  const { path } = useRouteMatch();
  const { company, dbUser, loading } = useAuth();

  const requireSetup =
    loading === false && dbUser?.tier === Tier.ENTERPRISE && !company;
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/setup`}>
          <CompanySetup />
        </Route>
        <Route exact path={`${path}/settings`}>
          {requireSetup ? (
            <Redirect
              to={{
                pathname: '/company/setup',
              }}
            />
          ) : (
            <CompanySettings />
          )}
        </Route>
      </Switch>
    </div>
  );
};

export default CompanyRouter;
